import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getPracticeCallLinks = (limit, lastSeen, callback) => {
  return async (dispatch) => {
    if (lastSeen) {
      dispatch({
        type: 'GET_PRACTICE_CALL_LINKS_WITH_PAGINATION',
      });
    } else {
      dispatch({ type: 'GET_PRACTICE_CALL_LINKS' });
    }
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.get(`/ads/link-tokens`, {
            params: {
              'request-id': reqId,
              limit,
              lastSeen,
              type: 'conversation_token',
            },
            headers: {
              Authorization: `Bearer ${token}`,
              // 'x-api-version': 'v2',
            },
          });
          if (response.status === 200) {
            if (lastSeen) {
              await dispatch({
                type: 'ADD_LINKS_TO_ALL_PRACTICE_LINKS',
                payload: {
                  links: response?.data,
                  lastTime: response?.data?.[response?.data?.length - 1]?.id,
                },
              });
            } else {
              await dispatch({
                type: 'GET_PRACTICE_CALL_LINKS_DONE',
                payload: {
                  links: response?.data,
                  lastTime: response?.data?.[response?.data?.length - 1]?.id,
                },
              });
            }
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'GET_PRACTICE_CALL_LINKS_FAILED',
              payload: `Failed to fetch links`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'GET_PRACTICE_CALL_LINKS_FAILED',
            payload: `Failed to fetch links`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'GET_PRACTICE_CALL_LINKS_FAILED',
        payload: `Failed to fetch links`,
      });
    }
  };
};

export default getPracticeCallLinks;
